// extracted by mini-css-extract-plugin
module.exports = {"header":"contacts_header__3I6zF","line":"contacts_line__ISF_B","boxFlex":"contacts_boxFlex__1lhbs"};